module.exports = __webpack_public_path__ + "eff44a984289a695c1c0a3fb3790368a.svg";